// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-sidebar {
  border-top-left-radius: 2.25rem;
  padding: 3rem 2.5rem;
}
.oc-sidebar img {
  width: 100%;
  max-width: 23.375rem;
  margin-bottom: 1.25rem;
}

.oc-sidebar-title {
  font-family: "DMSans-Bold";
  font-size: 22px;
  line-height: 1.2;
  text-transform: uppercase;
  color: var(--oc-primary-color);
}
.oc-sidebar p {
  font-size: 15px;
  line-height: 1.22;
  margin-bottom: 2.5rem;
}

.oc-sidebar .oc-btn {
  min-width: 10.8125rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".oc-sidebar {\n  border-top-left-radius: 2.25rem;\n  padding: 3rem 2.5rem;\n}\n.oc-sidebar img {\n  width: 100%;\n  max-width: 23.375rem;\n  margin-bottom: 1.25rem;\n}\n\n.oc-sidebar-title {\n  font-family: \"DMSans-Bold\";\n  font-size: 22px;\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: var(--oc-primary-color);\n}\n.oc-sidebar p {\n  font-size: 15px;\n  line-height: 1.22;\n  margin-bottom: 2.5rem;\n}\n\n.oc-sidebar .oc-btn {\n  min-width: 10.8125rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
